import React, { ComponentProps, PropsWithChildren } from 'react';
import HBText, {
    ITextProps
} from '@honeybook/hbui/dist/components/HBText/HBText';
import useEllipsis from '@honeybook/hbui/dist/components/common/useEllipsis';
import TooltipWrapper from '~/common/TooltipWrapper';

interface Props extends ITextProps {
    className?: string;
    tooltipProps?: ComponentProps<typeof TooltipWrapper>;
}

export const TextWithHintedEllipsis = ({
    className,
    children,
    tooltipProps = {},
    ...textProps
}: PropsWithChildren<Props>) => {
    const [ref, isEllipsisActive] = useEllipsis({
        textValue: children as string
    });

    return (
        <TooltipWrapper
            disabled={!isEllipsisActive}
            placement="top"
            targetContainerStyle={{
                display: 'flex',
                overflow: 'hidden'
            }}
            tooltipText={children}
            {...tooltipProps}
        >
            <HBText className={className} ref={ref} ellipsis {...textProps}>
                {children}
            </HBText>
        </TooltipWrapper>
    );
};

export default TextWithHintedEllipsis;
